import { Component, inject, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IonIcon } from '@ionic/angular/standalone';
import { CommonUtils } from '@utils/common/common.utils';
import {
  BANNER,
  BANNER_MESSAGE_TYPE,
  FILE_UPLOAD_RESPONSE,
} from './banner.constants';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  imports: [IonIcon, RouterLink],
})
export class BannerComponent {
  readonly commonUtils = inject(CommonUtils);

  readonly drawerOpen = input.required<boolean>();

  readonly emitExit = output<void>();

  readonly BANNER_400_MESSAGE = this.commonUtils.unknownBannerText;
  readonly BANNER_MESSAGE_TYPE = BANNER_MESSAGE_TYPE;
  readonly BANNER_TYPE = BANNER;
  readonly FILE_UPLOAD_RESPONSE = FILE_UPLOAD_RESPONSE;
  readonly bannerType = this.commonUtils.bannerType;

  clickExit() {
    //Reset file upload banner on close
    this.commonUtils.fileUploadResponse.set({
      uniqueUploadId: '',
      fileName: '',
      fileSize: 0,
      accepted: 0,
      rejected: [],
      received: 0,
      itemsNonProcessed: [],
    });
    this.emitExit.emit();
  }

  isRejectedDueToInspectArray(): boolean {
    return !!this.commonUtils.fileUploadResponse().rejectedDueToInspect;
  }
}
